import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ReplaceWhitespaceWithUnderscorePipe } from '../../pipes/replace-whitespace-with-underscore.pipe';

@Component({
  selector: 'app-cta-button',
  standalone: true,
  templateUrl: './cta-button.component.html',
  styleUrl: './cta-button.component.scss',
  imports: [InlineSVGModule, CommonModule, ReplaceWhitespaceWithUnderscorePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaButtonComponent {
  @Input() label?: string;
  @Input() url?: string;
}
